module.exports = __webpack_public_path__ + "img/no-hay-notificaciones.68bee714.png";